module.exports = __webpack_public_path__ + "static/media/sunInActive.9a2fa22b.svg";